// © Microsoft Corporation. All rights reserved.

import { ComponentStyles } from "@microsoft/fast-jss-manager";
import { DesignSystem, neutralForegroundRest, isDarkMode } from "@microsoft/fast-components-styles-msft";
import { SearchBoxClassNameContract } from "./SearchBox.classnames";
import { ColumnArrangement, getMediaQuerySelectorFor } from "@msnews/experiences-base";
import { directionSwitch } from "@microsoft/fast-jss-utilities";
/**
 * The search box component styles
 * @type {ComponentStyles<FeedNavigationClassNameContract, DesignSystem>}
 */
export const SearchBoxStyles: Partial<ComponentStyles<SearchBoxClassNameContract, DesignSystem>> = (config: DesignSystem) => {
    return {
        searchBox: {
            "& msft-search-box::part(root)": {
                [getMediaQuerySelectorFor(ColumnArrangement.c1)]: {
                    width: "273px"
                },
                [getMediaQuerySelectorFor(ColumnArrangement.c2)]: {
                    width: "542px"
                },
                [getMediaQuerySelectorFor(ColumnArrangement.c3)]: {
                    width: "530px"
                },
                [getMediaQuerySelectorFor(ColumnArrangement.c4)]: {
                    width: "710px"
                },
                "@media (min-width: 1920px)": {
                    width: "710px"
                },
                "max-width": "710px"
            },
            "& .voiceSearchButton": {
                background: isDarkMode(config) ? "#4a4a4a" : "#fff",
                border: "none",
                position: "absolute",
                height: "44px",
                width: "20px",
                padding: "0",
                left: directionSwitch("initial", "70px"),
                right: directionSwitch("70px", "initial"),
                "z-index": "2"
            }
        },
        useAnaheimUx: {
            "& msft-search-box": {
                "--search-box-radius": "22px",
                transition: "none",

                "&:focus": {
                    outline: "none"
                }
            },
            "& .autosuggestShown msft-search-box": {
                "--search-box-radius": "22px 22px 0 0"
            },
            "& msft-search-box::part(control)": {
                color: "var(--neutral-foreground-hint)",
                "font-family": "Segoe UI",
                "font-size": "var(--type-ramp-plus-1-font-size)",
                "padding-inline-start": "16px"
            },
            "& msft-search-box svg": {
                fill: "var(--accent-foreground-rest)",
                height: "24px",
                margin: "4px -2px 0",
                width: "24px"
            },
            "& form div#sw_as": {
                left: 0
            },
            "& form #sw_as .sa_as": {
                "border-style": "solid none none",
                "border-color": "var(--neutral-divider-rest)",
                "clip-path": "inset(0px -100% -100% -100%)"
            },
            "& form div#sw_as .sa_as, & form div#sw_as #sa_ul": {
                "border-radius": "0 0 22px 22px"
            },
            "& form #sw_as #sa_ul .sa_hd, form #sw_as #sa_ul .sa_tm": {
                "margin-inline-start": "16px"
            },
            "& form #sw_as .as_msbsugcontainer": {
                "padding-inline-start": "16px"
            }
        },
        searchHidden: {
            visibility: "hidden"
        },
        fakeCursor: {
            background: neutralForegroundRest,
            bottom: "14px",
            margin: "0 2px",
            position: "absolute",
            top: "14px",
            visibility: "hidden",
            width: "1px"
        },
        searchBingLogo: {
            margin: "12px 0",
            height: "20px",
            width: "14px",
            position: "absolute",
            left: directionSwitch("initial", "70px"),
            right: directionSwitch("70px", "initial")
        },
        voiceSearchSvg: {
            cursor: "pointer",
            height: "20px",
            width: "20px"
        }
    };
};